// extracted by mini-css-extract-plugin
export var active = "_mx-2";
export var recordingDot = "_mx-1";
export var recordingIndicator = "_mx-0";